import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The large centered intro shown before the anchored steps begin. The anchored steps themselves
// are loaded live from the Project Overview flow guide (see loadProjectOverviewGuideSteps.ts), not
// listed here. May be skipped at any step.
export const existingUserSteps: WelcomeStep[] = [{ key: "whats-new", label: "What's new", centered: true }];
